// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"PopupText_modal-scroll__Kqujr","popup-main":"PopupText_popup-main__sd2S_"};